exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#about_text[data-v-70afe78e]{width:90%;margin:auto}p[data-v-70afe78e]{text-align:left}.rightimg[data-v-70afe78e]{float:right;margin:7px 0 7px 7px}.lightfont[data-v-70afe78e]{color:#f0f8ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70afe78e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/About.vue
// module id = 255
// module chunks = 0